import { createSlice } from '@reduxjs/toolkit';
import * as Api from '../Api';

export const uploadSlice = createSlice({
  name: 'upload',
  initialState: {
    uploadResponse: null,
    selectedTemplateResponse: [],
    instanceResponse: [],
    createInstanceResponse: [],
    createAllInstances: [],
    numberOfRowsInserted: 0,
  },
  reducers: {
    setUploadResponse: (state, action) => {
      state.uploadResponse = action.payload;
    },
    getSelectedTemplateResponse: (state, action) => {
      state.selectedTemplateResponse = action.payload;
    },
    setInstanceResponse: (state, action) => {
      state.instanceResponse = action.payload;
    },
    setCreateInstanceResponse: (state, action) => {
      state.createInstanceResponse = action.payload;
    },
    setAllInstances: (state, action) => {
      state.createAllInstances = action.payload;
    },
    setRowsInserted: (state, action) => {
      state.numberOfRowsInserted = action.payload;
    },
  },
});

export function getExisitingTemplates(id) {
  return async (dispatch) => {
    console.log('id was', id);
    var response = await Api.getRequest('/template/forcustomer/v2/?customerId=' + id, 'GET');
    dispatch(setUploadResponse(response));
  };
}

export function getSpecificTemplates(id, callback) {
  return async (dispatch) => {
    var response = await Api.getRequest('/templateattribute/fortemplate?templateId=' + id, 'GET');
    dispatch(getSelectedTemplateResponse(response));
    if (callback) {
      callback(response);
    }
  };
}

export function getInstanceById(id) {
  return async (dispatch) => {
    var response = await Api.postRequest('/instance/', 'POST', id);
    dispatch(setInstanceResponse(response));
  };
}

export function createInstance(instanceDetails) {
  return async (dispatch) => {
    var response = await Api.postRequest('/instanceattribute/multiple/', 'POST', instanceDetails);
    dispatch(setCreateInstanceResponse(response));
  };
}

export function createInstanceMultiple(instanceDetails) {
  return async (dispatch) => {
    var response = await Api.postRequest('/instance/create/async/', 'POST', instanceDetails);
    dispatch(setRowsInserted(0));
    dispatch(setAllInstances(response));
  };
}

export function truncateAndCreateInstanceMultiple(instanceDetails) {
  return async (dispatch) => {
    var response = await Api.postRequest(
      '/instance/create/async/truncate',
      'POST',
      instanceDetails,
    );
    dispatch(setRowsInserted(0));
    dispatch(setAllInstances(response));
  };
}

export function resetUploadStates() {
  return async (dispatch) => {
    dispatch(setUploadResponse(null));
    dispatch(setCreateInstanceResponse([]));
    dispatch(setInstanceResponse([]));
    dispatch(getSelectedTemplateResponse([]));
    dispatch(setInstanceResponse([]));
    dispatch(setAllInstances([]));
    dispatch(setRowsInserted(0));
  };
}

export const {
  setUploadResponse,
  getSelectedTemplateResponse,
  setInstanceResponse,
  setCreateInstanceResponse,
  setAllInstances,
  setRowsInserted,
} = uploadSlice.actions;
export const setUploadSelector = (state) => state.upload.uploadResponse;
export const getSelectedTemplateSelector = (state) => state.upload.selectedTemplateResponse;
export const setInstanceSelector = (state) => state.upload.instanceResponse;
export const setCreateInstanceSelector = (state) => state.upload.createInstanceResponse;
export const setAllInstancesSelector = (state) => state.upload.createAllInstances;
export const setRowsInsertedSelector = (state) => state.upload.numberOfRowsInserted;
export default uploadSlice.reducer;
